module.exports = __webpack_public_path__ + "img/login_bg.7450e15f.png";